import {i18n} from '@/plugins/i18next';
import store from '@/store';
import Utils from '@/modules/core/services/utils';
import InfoService from '@/modules/core/services/info-service';
import {Role} from "@/modules/core/data/roles";

class ElevatorHeader {

  static invokeProvinceFn = null;
  static currentCountry = null;
  static allProvinces = [];

  constructor() {
    let user = store.state.auth.user;

    if (user && user.roles && user.roles.includes(Role.Admin)) {
      InfoService.readOptionsByUrl('display/province',
        (response) => {
          response.forEach(
            (province) => {
              province.translatedName = Utils.translateProvinces(province.countryName, province.name);
              ElevatorHeader.allProvinces.push(province);
            }
          );
        }
      );
    }
  }

  getHeader() {
    return [
      {
        text: i18n.t('common:name'),
        value: 'name',
        default: true,
        filter: {
          type: 'text',
          group: 0,
          order: 2
        }
      },
      {
        text: i18n.t('common:address'),
        value: 'address',
        default: true,
        filter: {
          type: 'text',
          group: 1,
          order: 1
        }
      },
      {
        text: i18n.t('common:city'),
        value: 'city',
        default: true,
        filter: {
          type: 'text',
          group: 1,
          order: 3
        }
      },
      {
        text: i18n.t('common:zip'),
        value: 'zip',
        default: true,
        filter: {
          type: 'text',
          group: 1,
          order: 2
        }
      },
      {
        text: i18n.t('common:country'),
        value: 'translatedCountry',
        default: true,
        filter: {
          type: 'select',
          group: 1,
          order: 4,
          forceTranslate: true,
          translateFn: Utils.translateAllCountries,
          url: 'country',
          invokeFns: {
            updateModel: this.updateCountryModelEvent
          }
        }
      },
      {text: i18n.t('display/elevator:overview.version'), value: 'version', default: true},
      {text: i18n.t('display/elevator:overview.motions'), value: 'ridesTotal', default: true},
      {text: i18n.t('display/elevator:overview.motion'), value: 'motion', default: true},
      {text: i18n.t('display/elevator:overview.mac'), value: 'mac', default: true},
      {text: i18n.t('display/elevator:overview.device-id'), value: 'deviceId', default: true},
      {text: i18n.t('display/elevator:overview.serialnumber-tablet'), value: 'serialnumberTablet', default: true},
      {text: i18n.t('display/elevator:overview.serialnumber-blackbox'), value: 'serialnumberBlackbox', default: true},
      {text: i18n.t('display/elevator:overview.serialnumber-camera'), value: 'serialnumberCamera', default: true},
      {text: i18n.t('display/elevator:overview.extern-emergency-id'), value: 'externEmergencyId', default: true},
      {text: i18n.t('display/elevator:overview.contract-start'), value: 'contractStart', default: true},
      {text: i18n.t('display/elevator:overview.contract-end'), value: 'contractEnd', default: true},
      {text: i18n.t('display/elevator:overview.is-emergency-set-up'), value: 'isEmergencySetUp', sortable: false, default: false},
      {
        text: i18n.t('common:active'),
        value: 'active',
        default: true,
        filter: {
          type: 'checkbox',
          group: 0,
          order: 5,
          hint: i18n.t('display/elevator:overview.filter.active-tooltip')
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.private'),
        value: 'private',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 2,
          order: 6,
          hint: i18n.t('display/elevator:overview.filter.private-tooltip')
        }
      },
      {text: i18n.t('display/elevator:overview.online'), value: 'online', default: true},
      {text: i18n.t('display/elevator:overview.last-online'), value: 'lastActive', default: true},
      {text: i18n.t('display/elevator:overview.first-online'), value: 'firstOnline', default: true},
      {text: i18n.t('display/elevator:overview.playlist'), value: 'playlist', default: true, sortable: false},
      {text: i18n.t('display/elevator:overview.io'), value: 'io', default: true},
      {text: i18n.t('display/elevator:overview.camera'), value: 'camera', default: true},
      {text: "", value: "controls", sortable: false, hideInColumnMenu: true},

        //these fields are hidden as they should not be displayed in table, but are required for filtering
      {
        text: 'Id',
        value: 'id',
        hide: true,
        filter: {
          type: 'text',
          group: 0,
          order: 1
        }
      },
      {
        text: i18n.t('common:customer'),
        value: 'customer',
        hide: true,
        filter: {
          type: 'multiselect',
          group: 0,
          order: 3,
          url: 'customer/all-customers'
        },
      },
      {
        text: i18n.t('common:province'),
        value: 'province',
        default: true,
        hide: true,
        filter: {
          type: 'select',
          group: 1,
          order: 5,
          options: [],
          invokeFns: {
            updateItems: this.updateProvinceItems,
            setInvokeVariable: this.setInvokeVariable
          }
        }
      },
      {
        text: i18n.t('common:tags'),
        value: 'tags',
        hide: true,
        filter: {
          type: 'multiselect',
          optionsName:'tags',
          group: 2,
          order: 1,
          url: 'display/tag'
        },
      },
      {
        text: i18n.t('display/elevator:overview.filter.black-tags'),
        value: 'blackTags',
        hide: true,
        filter: {
          type: 'multiselect',
          optionsName:'tags',
          group: 2,
          order: 2,
          url: 'display/tag'
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.phone'),
        value: 'phone',
        hide: true,
        filter: {
          type: 'text',
          group: 3,
          order: 1
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.demo'),
        value: 'demo',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 0,
          order: 7,
          hint: i18n.t('display/elevator:overview.filter.demo-tooltip')
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.test'),
        value: 'test',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 0,
          order: 6,
          hint: i18n.t('display/elevator:overview.filter.test-tooltip')
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.mails'),
        value: 'mails',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 3,
          order: 5,
          hint: i18n.t('display/elevator:overview.filter.mails-tooltip')
        }
      },
      {
        text: i18n.t('display/elevator:overview.camera'),
        value: 'camera',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 3,
          order: 6,
          hint: i18n.t('display/elevator:overview.filter.camera-tooltip')
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.sponsoring'),
        value: 'hasSponsoring',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 2,
          order: 4
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.advertising-bonus'),
        value: 'hasAdvertisingBonus',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 2,
          order: 5
        }
      },
      {
        text: i18n.t('display/elevator:edit.labels.data-tab.contract-type'),
        value: 'advertisingContract',
        hide: true,
        default: true,
        filter: {
          enum: 'true',
          type: 'select',
          group: 2,
          order: 3
        }
      },
      {
        text: i18n.t('display/elevator:edit.labels.data-tab.emergency-center'),
        value: 'emergencyCenter',
        hide: true,
        default: true,
        filter: {
          type: 'select',
          group: 3,
          order: 2,
          url: 'display/emergencycenter'
        }
      },
      {
        text: i18n.t('display/elevator:edit.labels.hardware-tab.pc-visit-name'),
        value: 'pcvisit',
        hide: true,
        filter: {
          type: 'text',
          group: 3,
          order: 3
        }
      },
      {
        text: i18n.t('display/elevator:edit.labels.data-tab.channel'),
        value: 'channel',
        hide: true,
        default: true,
        filter: {
          type: 'select',
          group: 3,
          order: 4,
          options: [
            {
              "id": "release",
              "translatedName": i18n.t('display/elevator:edit.selects.release')
            },
            {
              "beta": "beta",
              "translatedName": i18n.t('display/elevator:edit.selects.beta')
            }
          ]
        }
      },
      {
        text: i18n.t('common:contract'),
        value: 'hasContract',
        hide: true,
        filter: {
          type: 'checkbox',
          group: 1,
          order: 7
        }
      },
      {
        text: i18n.t('display/elevator:overview.filter.difference-in-year'),
        value: 'contractRuntime',
        hide: true,
        filter: {
          type: 'text',
          group: 1,
          order: 6
        }
      },
    ];
  }

  getUserHeader() {
    return [
      {text: i18n.t('common:name'), value: 'name'},
      {text: i18n.t('common:address'), value: 'address', default: true},
      {text: i18n.t('common:city'), value: 'city', default: true},
      {text: i18n.t('common:zip'), value: 'zip', default: true},
      {text: i18n.t('display/elevator:overview.motions'), value: 'ridesTotal', default: true},
      {text: "", value: "controls", sortable: false, hideInColumnMenu: true}
    ]
  }

  updateProvinceItems(items) {
    items = [];
    if (ElevatorHeader.currentCountry !== null && ElevatorHeader.allProvinces.length > 0) {
      let resultProvinces = [];
      let provinces = ElevatorHeader.allProvinces;

      for (let i = 0; i < provinces.length; i++) {
        if (provinces[i].country == ElevatorHeader.currentCountry) {
          resultProvinces.push(provinces[i]);
        }
      }

      items = resultProvinces;
    }

    return items
  }

  setInvokeVariable(invokeFn) {
    ElevatorHeader.invokeProvinceFn = invokeFn;
  }

  updateCountryModelEvent(model) {
    if (typeof model === 'number') {
      ElevatorHeader.currentCountry = model;
    } else {
      ElevatorHeader.currentCountry = null;
    }

    if (typeof ElevatorHeader.invokeProvinceFn === 'function') {
      ElevatorHeader.invokeProvinceFn();
    }

    return model;
  }

}

export default ElevatorHeader;
